module.exports = __webpack_public_path__ + "img/test.2d20d7cd.jpg";